import { z } from 'zod';

/**
 * Positive means strictly greater than 0.
 *
 * You must use parsing like {@link zPositiveInt.parse} to guarantee
 * that a number string is ACTUALLY a PositiveInt.
 */
export type PositiveInt = number & { __positiveint__: any };
export const zPositiveInt = z
  .number()
  .positive()
  .int()
  .transform((num) => num as PositiveInt);

/**
 * Use this method to determine when a number is a valid positive integer,
 * as Id's are required to be positive integers (> 0).
 */
export function validatePositiveInt(num?: number | null) {
  const parseResult = zPositiveInt.safeParse(num);
  if (parseResult.success) {
    return parseResult.data;
  }
  return undefined;
}

export function validatePositiveIntStr(numStr?: string | null) {
  return validatePositiveInt(Number(numStr));
}
